"use client";
import { useEffect } from "react";

export default function MailchimpPopup() {
  useEffect(() => {
    // Avoid injecting multiple times
    if (document.getElementById("mcjs")) return;

    const script = document.createElement("script");
    console.log("✅ Mailchimp script loaded");
  
    script.id = "mcjs";
    script.type = "text/javascript";
    script.async = true;
    script.src = "https://chimpstatic.com/mcjs-connected/js/users/8239287a4bfc45b5be9627544/2f2f89bdc52eb70d1616c1b6d.js";

    document.head.appendChild(script);

    return () => {
      // Optional cleanup
      script.remove();
    };
  }, []);

  return null;
}
